import { render, staticRenderFns } from "./PressNotesPgHeader.vue?vue&type=template&id=875e5aca&scoped=true&"
import script from "./PressNotesPgHeader.vue?vue&type=script&lang=js&"
export * from "./PressNotesPgHeader.vue?vue&type=script&lang=js&"
import style0 from "./PressNotesPgHeader.vue?vue&type=style&index=0&id=875e5aca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875e5aca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardTitle})
